import React from 'react';
import * as Yup from 'yup';
import _ from 'lodash';
import { FormContainer } from '~/views/blacklists/styles';
import { InputMask, InputGroup, Select } from '~/components/form';
import { MASK_CPF } from '~constants';
import { isValidCpf } from '~/helper';

export const BlacklistSchema = Yup.object().shape({
  name: Yup.string().required('Informe o nome'),
  identify: Yup.mixed().test('', 'Informe o CPF ou Número de registro', function(value) {
    let parent = this.parent || {};

    if (!parent.source || parent.source === 'national') {
      return value && isValidCpf(value);
    }
    return !!value;
  })
});

export const BlacklistForm = ({ values, errors, touched, previewMode }) => {

  return (
    <FormContainer>
      <Select
        name="source"
        label="Origem"
        options={{ values: [
          { value: 'national', label: 'Brasil' },
          { value: 'international', label: 'Estrangeiro' },
        ]}}
        hasError={_.get(errors, 'source') && _.get(touched, 'source')} />

      <InputGroup
        type="text"
        name="name"
        label="Nome"
        required={true}
        maxLength={100}
        autoFocus
        disabled={previewMode}
        hasError={errors.name && touched.name} />

      { (!values.source || values.source === 'national') ?
        <InputMask
          disabled={previewMode}
          mask={MASK_CPF}
          name="identify"
          label={'CPF'}
          required={true}
          hasError={errors.identify && touched.identify} />
        :
        <InputGroup
          type="text"
          maxLength={20}
          disabled={previewMode}
          name="identify"
          label={'Número de Registro'}
          required={true}
          hasError={errors.identify && touched.identify} />
      }
    </FormContainer>
  );
};
